import { LocationListModel } from './location-list.model';
import { MediaModel } from './media.model';
import { PoiListModel } from './poi-list.model';
import { PropertyListModel } from './property-list.model';
import { SearchFilterModel } from './search-filter.model';

export class LocationModel {
  Id?: number;
  Name?: string;
  Url?: string;
  Title?: string;
  MetaDescription?: string;
  Description?: string;
  KayakUrl?: string;
  Media?: MediaModel;
  Latitude: number = 0;
  Longitude: number = 0;
  GeoBounds: GeoBoundsModel = new GeoBoundsModel();
  SearchBoxDisplayName?: string;
  SearchBoxUrl?: string;
  Locations?: LocationListModel[];
}

export class GeoBoundsModel {
  North: number = 0;
  South: number = 0;
  East: number = 0;
  West: number = 0;
}
